import { IconProps } from './Icon';

export const PendingExecuteIcon = ({
  width = 18,
  height = 18,
  className,
  color,
}: IconProps) => (
  <>
    <svg
      className={className}
      color={color}
      enableBackground="0 0 512 512"
      height={height}
      id="Capa_1"
      viewBox="0 0 512 512"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m440.749 118.535-108.283-108.282c-6.611-6.612-15.4-10.253-24.75-10.253h-211.716c-19.299 0-35 15.701-35 35v442c0 19.299 15.701 35 35 35h320c19.299 0 35-15.701 35-35v-333.716c0-9.347-3.64-18.136-10.251-24.749zm-40.962 1.465h-63.787c-2.757 0-5-2.243-5-5v-63.786zm16.213 362h-320c-2.757 0-5-2.243-5-5v-442c0-2.757 2.243-5 5-5h205v85c0 19.299 15.701 35 35 35h85v327c0 2.757-2.243 5-5 5z" />
      <path d="m272.1 229h95.571c8.284 0 15-6.716 15-15s-6.716-15-15-15h-95.571c-8.284 0-15 6.716-15 15s6.715 15 15 15z" />
      <path d="m272.1 329h95.571c8.284 0 15-6.716 15-15s-6.716-15-15-15h-95.571c-8.284 0-15 6.716-15 15s6.715 15 15 15z" />
      <path d="m368.1 399h-96c-8.284 0-15 6.716-15 15s6.716 15 15 15h96c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
      <path d="m197.256 173.157-34.592 34.591-8.157-8.157c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l18.764 18.764c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394l45.198-45.198c5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.212 0z" />
      <path d="m197.256 280.794-34.592 34.592-8.157-8.157c-5.857-5.857-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l18.764 18.763c2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.464 10.606-4.394l45.198-45.198c5.858-5.858 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.212.001z" />
      <path d="m197.256 380.794-34.592 34.592-8.157-8.157c-5.857-5.857-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l18.764 18.763c2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.464 10.606-4.394l45.198-45.198c5.858-5.858 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.212.001z" />
    </svg>
  </>
);
